export const VALID_GUESSES = [
 'SML',
'dk2',
'dk3',
'dkL',
'WL2',
'WL3',
'SMA',
'WL4',
'MPA',
'MKD',
'MPD',
'MK7',
'SMw',
'SMK',
'SM6',
'MK6',
'dk6',
'MP2',
'MP3',
'RM6',
'MP4',
'MP7',
'MP8',
'MK8',
'SMP',
'RMw'

 ]
 
